
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMisc as ObiMiscElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-misc.js';
 
 
 

 
 export const ObiMisc = createComponent({
   react: React,
   tagName: 'obi-misc',
   elementClass: ObiMiscElement,
   events: {
     
   }
  });
 
 